export enum Group {
  ineligible = 0,
  control = 1,
  experiment = 2,
}
